import { Injectable } from '@angular/core';

import { ConfirmService } from '../ui.module/confirm.service';

export const confirmOopsInnerHTML = `
    <p class='--text-left'>
        It seems that you have lost all your spawns. But cheer up!
        Losing is fun in Screeps! Your scripts are always with you,
        your Global Control Level is well and alive, and you can start
        from scratch and quickly regain your former glory.
    </p>
    <p class='--text-left'>
        Click on the Respawn button below, and all your buildings and
        creeps will become unowned so that you can reset your spawn in
        any vacant room on the map. And don't forget to
        <a class='_link' href="http://docs.screeps.com/defense.html" app-nw-external-link>build&nbsp;defenses</a>
        this time!
    </p>
    <p class='--text-left'>
        Learn more about birth and death in
        <a class='_link' href="http://docs.screeps.com/respawn.html" app-nw-external-link>this&nbsp;article</a>.
    </p>
`;

@Injectable()
export class ShowDlgWorldOopsService {
    constructor(
        private _confirm: ConfirmService,
    ) {
    }

    show(): Promise<void> {
        return this._confirm.show({ data: {
            title: 'Oops!',
            innerHTML: confirmOopsInnerHTML,
            buttonOkLabel: 'Respawn'
        }});
    }
}
